import { find, isEmpty } from 'lodash';

export default {
  props: {
    active: Boolean,
  },
  watch: {
    /**
     * 탭 변환시마다 active flag 변경해준다.
     * @param  {[type]} tabName [description]
     * @return {[type]}         [description]
     * @author jda
     */
    activeTab: {
      immediate: true,
      handler(tabName) {
        if (isEmpty(tabName)) {
          return;
        }
        this.changeTab(tabName);
        this.$store.dispatch('setApmMainActiveTab', tabName);
      },
    },
    /**
     * 하위 탭을 스토어에 저장한다.
     * @param  {[type]} tabName [description]
     * @return {[type]}         [description]
     * @author jda
     */
    subActiveTab: {
      immediate: true,
      handler(tabName) {
        if (isEmpty(tabName)) {
          return;
        }
        this.changeTab(tabName);
        if (this.active) {
          this.$store.dispatch('setApmSubActiveTab', tabName);
        }
      },
    },
  },
  methods: {
    /**
     * 탭 활성화 플래그 변환
     * @param  {[type]} tabName [description]
     * @return {[type]}         [description]
     * @author jda
     */
    changeTab(tabName) {
      if (!isEmpty(tabName) && !isEmpty(this.tabs)) {
        const beforeActiveTab = find(this.tabs, 'active');
        if (!isEmpty(beforeActiveTab) && beforeActiveTab.name !== tabName) {
          beforeActiveTab.active = false;
        }
        this.tabs[tabName].active = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/apm/tab.js